
import { Select } from '@mantine/core';

const MantineSelect = (props: any) => {
  const { label, placeholder, data, className, value, classNames} = props;
  return (
    <Select
      {...props}
      label={label}
      placeholder={placeholder}
      data={data}
      className={className}
      value={value}
      classNames={classNames}
    />
  );
};

export default MantineSelect;
